





















































import Vue from "vue";

export default Vue.extend({
  name: "OpenDialog",
  data: () => ({
    selectedId: '',
    model: 1,
  }),
  computed: {
    boards: function() {
      return this.$store.state.localStoredBoards
    },
    buttonClickable: function() {
      return this.selectedId === this.$store.getters.getBoardId || !this.selectedId || !(this.selectedId.length > 0)
    }
  },
  methods: {
    selectBoard(event: any) {
      this.selectedId = event
    },
    loadBoard() {
      this.$store.dispatch('bindCurrentBoard', this.selectedId)
    },
    deleteBoard(id: string) {
      this.$store.commit('deleteBoardFromLocalBoards', id)
    }
  }
});
